export const ADMIN_GET_ADMIN_LIST_BEGIN = 'ADMIN_GET_ADMIN_LIST_BEGIN';
export const ADMIN_GET_ADMIN_LIST_SUCCESS = 'ADMIN_GET_ADMIN_LIST_SUCCESS';
export const ADMIN_GET_ADMIN_LIST_FAILURE = 'ADMIN_GET_ADMIN_LIST_FAILURE';
export const ADMIN_GET_ADMIN_LIST_DISMISS_ERROR = 'ADMIN_GET_ADMIN_LIST_DISMISS_ERROR';
export const ADMIN_SUBMIT_ADMIN_BEGIN = 'ADMIN_SUBMIT_ADMIN_BEGIN';
export const ADMIN_SUBMIT_ADMIN_SUCCESS = 'ADMIN_SUBMIT_ADMIN_SUCCESS';
export const ADMIN_SUBMIT_ADMIN_FAILURE = 'ADMIN_SUBMIT_ADMIN_FAILURE';
export const ADMIN_SUBMIT_ADMIN_DISMISS_ERROR = 'ADMIN_SUBMIT_ADMIN_DISMISS_ERROR';
export const ADMIN_DELETE_ADMIN_BEGIN = 'ADMIN_DELETE_ADMIN_BEGIN';
export const ADMIN_DELETE_ADMIN_SUCCESS = 'ADMIN_DELETE_ADMIN_SUCCESS';
export const ADMIN_DELETE_ADMIN_FAILURE = 'ADMIN_DELETE_ADMIN_FAILURE';
export const ADMIN_DELETE_ADMIN_DISMISS_ERROR = 'ADMIN_DELETE_ADMIN_DISMISS_ERROR';
export const ADMIN_ADMIN_MODAL_CHANGE = 'ADMIN_ADMIN_MODAL_CHANGE';
export const ADMIN_CHOOSE_CURRENT_ADMIN = 'ADMIN_CHOOSE_CURRENT_ADMIN';
export const ADMIN_GET_DEPT_LIST_BEGIN = 'ADMIN_GET_DEPT_LIST_BEGIN';
export const ADMIN_GET_DEPT_LIST_SUCCESS = 'ADMIN_GET_DEPT_LIST_SUCCESS';
export const ADMIN_GET_DEPT_LIST_FAILURE = 'ADMIN_GET_DEPT_LIST_FAILURE';
export const ADMIN_GET_DEPT_LIST_DISMISS_ERROR = 'ADMIN_GET_DEPT_LIST_DISMISS_ERROR';
export const ADMIN_SUBMIT_DEPT_BEGIN = 'ADMIN_SUBMIT_DEPT_BEGIN';
export const ADMIN_SUBMIT_DEPT_SUCCESS = 'ADMIN_SUBMIT_DEPT_SUCCESS';
export const ADMIN_SUBMIT_DEPT_FAILURE = 'ADMIN_SUBMIT_DEPT_FAILURE';
export const ADMIN_SUBMIT_DEPT_DISMISS_ERROR = 'ADMIN_SUBMIT_DEPT_DISMISS_ERROR';
export const ADMIN_DELETE_DEPT_BEGIN = 'ADMIN_DELETE_DEPT_BEGIN';
export const ADMIN_DELETE_DEPT_SUCCESS = 'ADMIN_DELETE_DEPT_SUCCESS';
export const ADMIN_DELETE_DEPT_FAILURE = 'ADMIN_DELETE_DEPT_FAILURE';
export const ADMIN_DELETE_DEPT_DISMISS_ERROR = 'ADMIN_DELETE_DEPT_DISMISS_ERROR';
export const ADMIN_DEPT_MODAL_CHANGE = 'ADMIN_DEPT_MODAL_CHANGE';
export const ADMIN_CHOOSE_CURRENT_DEPT = 'ADMIN_CHOOSE_CURRENT_DEPT';
export const ADMIN_GET_ALL_DEPT_BEGIN = 'ADMIN_GET_ALL_DEPT_BEGIN';
export const ADMIN_GET_ALL_DEPT_SUCCESS = 'ADMIN_GET_ALL_DEPT_SUCCESS';
export const ADMIN_GET_ALL_DEPT_FAILURE = 'ADMIN_GET_ALL_DEPT_FAILURE';
export const ADMIN_GET_ALL_DEPT_DISMISS_ERROR = 'ADMIN_GET_ALL_DEPT_DISMISS_ERROR';
export const ADMIN_GET_DICNAME_LIST_BEGIN = 'ADMIN_GET_DICNAME_LIST_BEGIN';
export const ADMIN_GET_DICNAME_LIST_SUCCESS = 'ADMIN_GET_DICNAME_LIST_SUCCESS';
export const ADMIN_GET_DICNAME_LIST_FAILURE = 'ADMIN_GET_DICNAME_LIST_FAILURE';
export const ADMIN_GET_DICNAME_LIST_DISMISS_ERROR = 'ADMIN_GET_DICNAME_LIST_DISMISS_ERROR';
export const ADMIN_SUBMIT_DICNAME_BEGIN = 'ADMIN_SUBMIT_DICNAME_BEGIN';
export const ADMIN_SUBMIT_DICNAME_SUCCESS = 'ADMIN_SUBMIT_DICNAME_SUCCESS';
export const ADMIN_SUBMIT_DICNAME_FAILURE = 'ADMIN_SUBMIT_DICNAME_FAILURE';
export const ADMIN_SUBMIT_DICNAME_DISMISS_ERROR = 'ADMIN_SUBMIT_DICNAME_DISMISS_ERROR';
export const ADMIN_DELETE_DICNAME_BEGIN = 'ADMIN_DELETE_DICNAME_BEGIN';
export const ADMIN_DELETE_DICNAME_SUCCESS = 'ADMIN_DELETE_DICNAME_SUCCESS';
export const ADMIN_DELETE_DICNAME_FAILURE = 'ADMIN_DELETE_DICNAME_FAILURE';
export const ADMIN_DELETE_DICNAME_DISMISS_ERROR = 'ADMIN_DELETE_DICNAME_DISMISS_ERROR';
export const ADMIN_DICNAME_MODAL_CHANGE = 'ADMIN_DICNAME_MODAL_CHANGE';
export const ADMIN_CHOOSE_CURRENT_DICNAME = 'ADMIN_CHOOSE_CURRENT_DICNAME';
export const ADMIN_GET_DICVALUES_LIST_BEGIN = 'ADMIN_GET_DICVALUES_LIST_BEGIN';
export const ADMIN_GET_DICVALUES_LIST_SUCCESS = 'ADMIN_GET_DICVALUES_LIST_SUCCESS';
export const ADMIN_GET_DICVALUES_LIST_FAILURE = 'ADMIN_GET_DICVALUES_LIST_FAILURE';
export const ADMIN_GET_DICVALUES_LIST_DISMISS_ERROR = 'ADMIN_GET_DICVALUES_LIST_DISMISS_ERROR';
export const ADMIN_SUBMIT_DICVALUES_BEGIN = 'ADMIN_SUBMIT_DICVALUES_BEGIN';
export const ADMIN_SUBMIT_DICVALUES_SUCCESS = 'ADMIN_SUBMIT_DICVALUES_SUCCESS';
export const ADMIN_SUBMIT_DICVALUES_FAILURE = 'ADMIN_SUBMIT_DICVALUES_FAILURE';
export const ADMIN_SUBMIT_DICVALUES_DISMISS_ERROR = 'ADMIN_SUBMIT_DICVALUES_DISMISS_ERROR';
export const ADMIN_DELETE_DICVALUES_BEGIN = 'ADMIN_DELETE_DICVALUES_BEGIN';
export const ADMIN_DELETE_DICVALUES_SUCCESS = 'ADMIN_DELETE_DICVALUES_SUCCESS';
export const ADMIN_DELETE_DICVALUES_FAILURE = 'ADMIN_DELETE_DICVALUES_FAILURE';
export const ADMIN_DELETE_DICVALUES_DISMISS_ERROR = 'ADMIN_DELETE_DICVALUES_DISMISS_ERROR';
export const ADMIN_DICVALUES_MODAL_CHANGE = 'ADMIN_DICVALUES_MODAL_CHANGE';
export const ADMIN_CHOOSE_CURRENT_DICVALUES = 'ADMIN_CHOOSE_CURRENT_DICVALUES';
export const ADMIN_GET_DIC_LIST_BEGIN = 'ADMIN_GET_DIC_LIST_BEGIN';
export const ADMIN_GET_DIC_LIST_SUCCESS = 'ADMIN_GET_DIC_LIST_SUCCESS';
export const ADMIN_GET_DIC_LIST_FAILURE = 'ADMIN_GET_DIC_LIST_FAILURE';
export const ADMIN_GET_DIC_LIST_DISMISS_ERROR = 'ADMIN_GET_DIC_LIST_DISMISS_ERROR';
export const ADMIN_GET_ACONFIG_LIST_BEGIN = 'ADMIN_GET_ACONFIG_LIST_BEGIN';
export const ADMIN_GET_ACONFIG_LIST_SUCCESS = 'ADMIN_GET_ACONFIG_LIST_SUCCESS';
export const ADMIN_GET_ACONFIG_LIST_FAILURE = 'ADMIN_GET_ACONFIG_LIST_FAILURE';
export const ADMIN_GET_ACONFIG_LIST_DISMISS_ERROR = 'ADMIN_GET_ACONFIG_LIST_DISMISS_ERROR';
export const ADMIN_SUBMIT_ACONFIG_BEGIN = 'ADMIN_SUBMIT_ACONFIG_BEGIN';
export const ADMIN_SUBMIT_ACONFIG_SUCCESS = 'ADMIN_SUBMIT_ACONFIG_SUCCESS';
export const ADMIN_SUBMIT_ACONFIG_FAILURE = 'ADMIN_SUBMIT_ACONFIG_FAILURE';
export const ADMIN_SUBMIT_ACONFIG_DISMISS_ERROR = 'ADMIN_SUBMIT_ACONFIG_DISMISS_ERROR';
export const ADMIN_DELETE_ACONFIG_BEGIN = 'ADMIN_DELETE_ACONFIG_BEGIN';
export const ADMIN_DELETE_ACONFIG_SUCCESS = 'ADMIN_DELETE_ACONFIG_SUCCESS';
export const ADMIN_DELETE_ACONFIG_FAILURE = 'ADMIN_DELETE_ACONFIG_FAILURE';
export const ADMIN_DELETE_ACONFIG_DISMISS_ERROR = 'ADMIN_DELETE_ACONFIG_DISMISS_ERROR';
export const ADMIN_ACONFIG_MODAL_CHANGE = 'ADMIN_ACONFIG_MODAL_CHANGE';
export const ADMIN_CHOOSE_CURRENT_ACONFIG = 'ADMIN_CHOOSE_CURRENT_ACONFIG';
export const ADMIN_RESET_PASSWORD_BEGIN = 'ADMIN_RESET_PASSWORD_BEGIN';
export const ADMIN_RESET_PASSWORD_SUCCESS = 'ADMIN_RESET_PASSWORD_SUCCESS';
export const ADMIN_RESET_PASSWORD_FAILURE = 'ADMIN_RESET_PASSWORD_FAILURE';
export const ADMIN_RESET_PASSWORD_DISMISS_ERROR = 'ADMIN_RESET_PASSWORD_DISMISS_ERROR';





// WEBPACK FOOTER //
// ./src/features/admin/redux/constants.js